import React, { useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Box, Toolbar, Typography, Link, Button } from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Disclaimertext = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const receivedNumber = location.state?.number;
  const navigate = useNavigate();

  // ✅ Checkbox state
  const [checked, setChecked] = useState(false);

  return (
    <Box>
      <Toolbar>
        <div className='diclaimer-Screen'>
          {receivedNumber}

          <div className='disclainerWrapper'>
            <Typography variant='h2'>{t('terms_title')}</Typography>

            <div className='tems-condition-content'>
              <Typography variant='body1' sx={{ py: '20px' }}>
                ओरो कैंसर वॉच स्क्रीनिंग टूल को ओरल पोटेंशियली मैलिग्नेंट डिसऑर्डर्स (OPMD) से जुड़े जोखिम कारकों की पहचान करने के लिए डिज़ाइन किया गया है और यह एक निश्चित नैदानिक उपकरण नहीं है। सभी उत्पन्न परिणाम सांकेतिक हैं; 'कम जोखिम' परिणाम बीमारी की उपस्थिति को खारिज नहीं करता है, और 'उच्च जोखिम' परिणाम कैंसर की पुष्टि नहीं करता है। उपयोगकर्ताओं को दंत चिकित्सक या ऑन्कोलॉजिस्ट से परामर्श करने की सख्त सलाह दी जाती है।
              </Typography>

              <Typography variant='body1' sx={{ py: '5px' }}>
                The [Orocancer Watch] screening tool is designed to identify risk factors associated with Oral Potentially Malignant Disorders (OPMD) and is not a definitive diagnostic device. All results generated are indicative; a 'Low Risk' result does not rule out the presence of disease, and a 'High Risk' result does not confirm malignancy. Users are strictly advised to consult a dental surgeon or oncologist.
              </Typography>
            </div>

            {/* ✅ Checkbox */}
            <FormGroup className='custum-checkbox'>
              <FormControlLabel
                required
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                }
                label='मैं ऊपर दिए गए नियमों और शर्तों से सहमत हूं / I agree to terms and conditions above'
              />
            </FormGroup>

            <div className='custom-btn'>
              {/* Back Button */}
              <Link
                component={RouterLink}
                to="/"
                className='back-btn'
                sx={{ marginTop: '30px', marginRight: '15px' }}
              >
                {t('back_btn')}
              </Link>

              {/* ✅ Next Button (Disabled until checkbox checked) */}
              <Button
                variant="contained"
                disabled={!checked}
                sx={{ marginTop: '30px' }}
                onClick={() =>
                  navigate("/Paitentsform", {
                    state: { number: receivedNumber }
                  })
                }
              >
                {t('start_chat')}
              </Button>
            </div>
          </div>
        </div>
      </Toolbar>
    </Box>
  );
};

export default Disclaimertext;